const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  userName: {
    margin: '0 0 0 10px',
    fontWeight: 500,
    '& + p': {
      margin: '0 0 0 10px',
    },
  },
  avatar: {
    borderRadius: '50%',
    width: 40,
    height: 40,
  },
}

export default styles;